import React, { memo, ReactNode } from 'react';
import { Icon } from 'Components/Icons';

import { Modal } from 'Components/Modal';

import classes from './addLogModal.module.css';

interface Props {
  // modal variables
  isOpen: boolean;
  children: ReactNode;

  // modal functions
  closeModal: (e: any) => void;
}

function AddMoistureLogModal({ isOpen, closeModal, children }: Props) {
  return (
    <Modal title="Damage Material Log" isOpen={isOpen} classes={{ modalDialog: classes.modalOverride }}>
      <h5 className={classes.heading}>
        Damage Material Log <Icon type="close" className={classes.closeModal} onClick={closeModal} />
      </h5>
      {children}
    </Modal>
  );
}

const AddMoistureLogModalMemo = memo(AddMoistureLogModal);

export { AddMoistureLogModalMemo as AddMoistureLogModal };
